import { NavLink  } from 'react-router-dom';

export default function NavSchedulePay() {
  	return (
        <div className="nav-align-top">
            <ul className="nav nav-pills flex-column flex-md-row mb-6">
                <li className="nav-item">
                    <NavLink to="/schedule-pay" className="nav-link">
                        <i className="bx bx-euro me-1_5 bx-md"></i>
                        Incassi
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/credit-note" className="nav-link">
                        <i className="bx bx-note me-1_5 bx-md"></i>
                        Note di Credito
                    </NavLink>
                </li>
            </ul>
        </div>
	);
}